import { URL } from '../../../../config'
import { getRequest } from '../../../../utils/httpRequest'

export const getAthletes = function (schoolId,teamDivision,gender,searchBy,searchValue,token) 
{
  
  const athleteEndpoint = `/athletes`
  const  athleteURL =  `${URL.postevent}${athleteEndpoint}/${schoolId}/${teamDivision}/${gender}/${searchBy}/${searchValue}` 
  return getRequest(athleteURL,'json',token)
}


// WEBPACK FOOTER //
// ./src/components/pages/Athlete/api/getAthletes.js